(function() {
    'use strict';
    angular
        .module('atheer.services')
        .factory('EmailLayout', EmailLayout);

    /* @ngInject */
    function EmailLayout($resource) {
        var resourceUrl = 'api/system/email-layouts/:id';

        return $resource(resourceUrl, {
            id: '@id'
        }, {
            'query': {
                method: 'GET',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function(data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': {
                method: 'PUT'
            }
        });
    }
})();
